import { Loader } from '@googlemaps/js-api-loader';
import { sendErrReport } from '~/infra/utils';
export var PlacesServiceStatus = /*#__PURE__*/ function(PlacesServiceStatus) {
    /**
     * This request was invalid.
     */ PlacesServiceStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
    /**
     * The place referenced was not found.
     */ PlacesServiceStatus["NOT_FOUND"] = "NOT_FOUND";
    /**
     * The response contains a valid result.
     */ PlacesServiceStatus["OK"] = "OK";
    /**
     * The application has gone over its request quota.
     */ PlacesServiceStatus["OVER_QUERY_LIMIT"] = "OVER_QUERY_LIMIT";
    /**
     * The application is not allowed to use the <code>PlacesService</code>.
     */ PlacesServiceStatus["REQUEST_DENIED"] = "REQUEST_DENIED";
    /**
     * The <code>PlacesService</code> request could not be processed due to a
     * server error. The request may succeed if you try again.
     */ PlacesServiceStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    /**
     * No result was found for this request.
     */ PlacesServiceStatus["ZERO_RESULTS"] = "ZERO_RESULTS";
    return PlacesServiceStatus;
}({});
const ignoreSentryStatuses = [
    "NOT_FOUND",
    "ZERO_RESULTS",
    "OK",
    "UNKNOWN_ERROR"
];
export async function loadGoogleMaps() {
    if (!window.googleMapsApiKey) {
        return undefined;
    }
    return new Loader({
        apiKey: window.googleMapsApiKey,
        version: 'weekly',
        libraries: [
            'places'
        ]
    }).load().then((google)=>{
        const autocompleteService = new google.maps.places.AutocompleteService();
        const placesService = new google.maps.places.PlacesService(document.createElement('div'));
        const googleMaps = {
            getPlacePredictions: (request, callback)=>autocompleteService.getPlacePredictions(request, (predictions, status)=>{
                    if (!ignoreSentryStatuses.includes(status)) {
                        sendErrReport("GoogleMaps getPlacePredictions error: ".concat(status));
                    }
                    callback && callback(predictions, status);
                }),
            getPlaceDetails: (request, callback)=>placesService.getDetails(request, (result, status)=>{
                    if (!ignoreSentryStatuses.includes(status) || !result) {
                        return sendErrReport("GoogleMaps getDetails error: ".concat(status));
                    }
                    callback && callback(result, status);
                })
        };
        return googleMaps;
    }).catch(()=>{
        sendErrReport('loadGoogleMapsError');
        return undefined;
    });
}
